export default __webpack_public_path__ + "static/media/icon-card-mx-flight-cycles-limit.7c4e46bd.svg";